let navbar;
let triggerContainer;
let toggleButtons;
let triggerLink;
let lastMenuItem;
let menuVisible = false;       // current visibility state of menu

navbar = document.querySelector('.nav-links');
triggerContainer = document.querySelectorAll('.has-subnav');
toggleButtons = document.querySelectorAll('.toggle-button');
triggerLink = document.querySelector('.has-subnav > a');
lastMenuItem = document.querySelector('.has-subnav > ul > li:last-of-type > a');

// /**
//   Menu visibility
// */

const showMenu = (e) => {
  const item = e.target.closest(".has-subnav");
  if (item) {
    const itemLink = item.querySelector("a");
    const itemBtn = item.querySelector(".toggle-button");
    item.classList.add("active")
    itemLink.setAttribute('aria-expanded', true);
    itemBtn.setAttribute('aria-expanded', true);
    menuVisible = true;
  }
}

const hideMenu = (e) => {
  const item = e.target.closest(".has-subnav");
  if (item) {
    const itemLink = item.querySelector("a");
    const itemBtn = item.querySelector(".toggle-button");
    item.classList.remove("active");
    itemLink.setAttribute('aria-expanded', false);
    itemBtn.setAttribute('aria-expanded', false);
    menuVisible = false;
  }
}

const toggleMenu = (e) => {
  if(menuVisible) {
    hideMenu(e);
  } else {
    showMenu(e);
  }
}

// /**
//   Event handlers
// */
const handleBodyClick = (e) => {
  if(navbar && !navbar.contains(e.target)) {
    hideMenu(e);
  }
}

const triggerKeydownHandler = (e) => {
  // Hide the menu a keyboard user tabs out of it or presses Escape
  let parent = e.target.parentNode.parentNode;
  let lastItem = parent.querySelector('ul > li:last-of-type > a');
  if((e.key === 'Tab' && !e.shiftKey && e.target === lastItem) || e.key == 'Escape') {
    hideMenu(e);

    // Move focus back to the menu toggle button if Escape was pressed
    if(e.key == 'Escape') {
      parent.focus();
    }
  }
}

if(navbar){
  navbar.addEventListener("mouseover", function (e) {
    showMenu(e);
  });

  navbar.addEventListener("mouseout", function (e) {
    hideMenu(e);
  });
}
// Hide the menu when the user tabs out of it
// triggerContainer.addEventListener('keydown', triggerKeydownHandler);
Array.from(triggerContainer).forEach(function(element) {
  element.addEventListener("keydown", function (e) {
    triggerKeydownHandler(e);
  });
});

// Toggle the menu when the trigger is activated
Array.from(toggleButtons).forEach(function(element) {
  element.addEventListener("click", function (e) {
    toggleMenu(e);
  });
});

// Close the menu when the user activates something outside the navbar.
document.body.addEventListener('click', handleBodyClick);